<template>
	<div class="basic_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('user.myInvestment')}}</div>
		</div>
		<div class="total-main">
		<!-- <div class="total-bar">
			<div v-if="usdt_to_change>=0" class="tot-cell flex_center">
				<span class="iconfont icon-up text-green"></span>
				<span >{{usdt_to_usd}} +<span class="color">{{usdt_to_change}}(+{{p}}%)</span></span>
			</div>
			<div v-else class="tot-cell flex_center">
				<span class="iconfont icon-down text-red"></span>
				<span >{{usdt_to_usd}} -<span class="color">{{usdt_to_change}}(-{{p}}%)</span></span>
			</div>
			<div class="tot-desc flex_center">
				<span class="iconfont icon-time-circle text-red"></span><span>{{$t('utils.sj_tips')}}</span>
			</div>
		</div> -->
		<div class="money_box">
			<div class="item">
				<div class="m-card">
					<p class="info">{{$t('user.uncollectedPrincipal')}}</p>
					<p class="money_num" v-html="data.on_money"></p>
				</div>
			</div>
			<div class="item">
				<div class="m-card">
				<p class="info">{{$t('user.uncollectedInterest')}}</p>
				<p class="money_num" v-html="data.on_apr_money"></p>
				</div>
			</div>
			<div class="item">
				<div class="m-card">
				<p class="info">{{$t('user.cumulativeIncome')}}</p>
				<p class="money_num" v-html="data.ok_apr_money"></p>
				<!---<p class="money_num" v-html="'<span>'+$t('utils.moneyMark')+'</span>'+data.ok_apr_money"></p>-->
				</div>
			</div>
		</div>
		<h3 class="notes_tit">{{$t('orders.record')}}</h3>
		<van-empty :description="$t('orders.noOrders')" v-if="empty" />
		<div class="scrollBox">
			<div class="notes_box" v-if="!empty" v-for="i in data.list">
				<div class="timer">
					<span class="time">{{ i.time }}</span>
					<span class="tag ing" v-if="i.status==0">{{$t('orders.unfinish')}}</span>
					<span class="tag finish" v-if="i.status==1">{{$t('orders.finish')}}</span>
				</div>
				<div class="items-flex">
					<div class="item-ico">
					 
						<img v-if="i.cover" class=" round" :src="i.cover" alt="">
						<img v-else class=" round" src="../images/new/bch.png" alt=""> 
						
					</div>
					<div class="flex_bd">
						<div class="item_div1">
							<p>
								{{i[lang]}}
							</p>
						</div>
						<div class="item_div2">
							<div class="item_min">
								<p>{{i.money2}}</p>
								<p>{{$t('utils.investmentAmount')}}</p>
							</div>
							<div class="item_rate">
								<p>{{i.shouyi}}</p>
								<p>{{$t('utils.income')}}</p>
							</div>
							<div class="item_day">
								<p>{{i.day}}{{$t('utils.day')}}</p>
								<p>{{$t('utils.cycle')}}</p>
							</div>
							<!-- <div class="item_day" v-if="i.status==0">
								<p style="padding: 2px 0;">
									<van-count-down :time="i.left_time*1000" style="font-size: 12px; line-height: 16px;">
									  <template #default="timeData">
									    <span class="block">{{ timeData.days }}</span>
									    <span class="colon">:</span>
									    <span class="block">{{ timeData.hours }}</span>
									    <span class="colon">:</span>
									    <span class="block">{{ timeData.minutes }}</span>
									    <span class="colon">:</span>
									    <span class="block">{{ timeData.seconds }}</span>
									  </template>
									</van-count-down>
								</p>
								<p><span class="iconfont icon-shijian text-red"></span> {{$t('utils.cycle')}}</p>
							</div> -->
						</div>
					</div>
				</div>
				<div class="timer2">
					<span class="time"></span>
					<span class="tag ing" @click="confirm1(i)">{{$t('orders.viewhetong')}}</span>
				</div>
			</div>
		</div>
		</div>
		<van-dialog v-model="show_ht" theme="round-button" :confirmButtonText="$t('utils.confirm')"  style="top:50%;">
			
			<div class="show-tc-body">
				<div class="popup" v-html="hetongContent2"></div>
			</div>
			
		</van-dialog>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		Empty,CountDown
	} from "vant";

	import Fetch from "../../utils/fetch";
	Vue.use(Empty);
	Vue.use(CountDown);

	export default {
		name: "order",
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				usdt_to_usd: '',
				p: '',
				usdt_to_change: '',
				empty: false,
				time: 30 * 60 * 60 * 1000,
				show_ht:false,
				hetongContent:'',
				hetongContent2:'',
				sku: [],
				usinfo: []
			};
		},
		created() {
			this.$parent.footer("order");
		},
		mounted() {
			this.start();
			this.getHeTong();
			this.getUserInfo();
		},
		methods: {
			start() {
				Fetch("/user/order").then((r) => {
					this.data = r.data;
					this.usdt_to_change = r.data.usdt_to_change;
					this.usdt_to_usd = r.data.usdt_to_usd;
					this.p = (this.usdt_to_change/this.usdt_to_usd).toFixed(3);
					r.data.list.length == 0 ?
						(this.empty = true) :
						(this.empty = false);
				});
			},
			wan(str) {
				var num = parseFloat(str);
				if (num > 99999) {
					return `${(num / 10000).toFixed(2)}`;
				} else {
					return str || 0;
				}
			},
			lookHT(id) {
				this.$router.push("/contract/" + id);
			},
			getUserInfo(){
				Fetch('/user/info').then(res => {
					this.usinfo = res.data;
				})
			},
			getHeTong(){
				Fetch('/index/article_detail', {
					id: 15
				}).then(res => {
					this.hetongContent = res.data.content;
				})
			},
			confirm1(val){
				this.sku=val;
				let htmlcon='';
				htmlcon+='<table cellpadding="1" cellspacing="0" bgcolor="#cccccc" width="100%">';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff" valign="top">' + this.$t('utils.pro_name')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku[this.lang] + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.tz_name')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.usinfo.name + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.pro_company')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.$t('utils.pro_company1') + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.db_company')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku.db_complany + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.investmentAmount')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + this.sku.money2 + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<tr>';
				htmlcon+='	<td width="30%" height="26" bgcolor="#ffffff">' + this.$t('utils.yuji_sy2')+'</td>';
				htmlcon+='	<td width="70%" bgcolor="#ffffff">' + (this.sku.money*this.sku.day*this.sku.rate/100).toFixed(2) + '</td>';
				htmlcon+='</tr>';
				htmlcon+='<table>';

				//章
				let zhangcon='';
				zhangcon+='<table cellpadding="0" cellspacing="0" width="100%">';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_jia') + this.$t('utils.pro_company1') +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">&nbsp;</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_yi') + this.usinfo.name +'</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">&nbsp;</td>';
				zhangcon+='</tr>';
				zhangcon+='<tr>';
				zhangcon+='	<td valign="top">' + this.$t('utils.zhang_db') + this.sku.db_complany +'</td>';
				zhangcon+='</tr>';
				// zhangcon+='<tr>';
				// zhangcon+='	<td valign="top"><img src="' + this.sku.db_zhang +'" width="100" height="100" /></td>';
				// zhangcon+='</tr>';
				zhangcon+='<table>';
				this.hetongContent2 = htmlcon + this.hetongContent + zhangcon;
				this.show_ht=true;
			},
		},
	};
</script>

<style lang="less" scoped>
	.total-main{
		overflow: hidden;
	}
	.basic_wrap{
		padding-top: 44px;
	}
	.red_top_bg {
		top: 0;
		width: 100%;
		position: fixed;
		z-index: 15;
	}

	.money_box {
		//background-color: #f7f7f7;
		display: flex;
		justify-content: space-around;
		padding:15px 5px;
		.item {
			width: 33.33%;
			padding:0 6px;
			text-align: center;
			.money_num {
				font-size: 14px;
				line-height: 25px;
				font-weight: bold;
				white-space: normal;
				word-break: normal;
				text-align: center;
				color: #ef5040;
			}

			.info {
				font-size: 14px;
				line-height: 20px;
				margin-top: 5px;
				color: #ccc;
			}
		}
	}

	.notes_tit {
		width: 100%;
		line-height: 44px;
		height: 44px;
		font-size: 14px;
		color: #ffffff;
		padding: 0 14px;
		background: #321770;
		z-index: 2;
	}

	.notes_box {
		width: 100%;
		padding-bottom: 2px;
		background: #231050;
		box-shadow: -2px 2px 9px 2px rgba(160, 160, 160, 0.15);
		margin-bottom: 15px;
		.timer {
			background-color: #1b0649;
			padding: 10px 14px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.time{
				color: #999999;
			}
			.tag {
				font-style: normal;
				padding:8px 12px;
				border-radius: 5px;
				text-align: center;
				color: #FFFFFF;
				min-width: 60px;
			}

			.ing {
				background: #ff5c4f;
			}

			.finish {
				font-style: normal;
				background: #04c382;
			}
		}
		.timer2 {
			background-color: #1b0649;
			padding: 5px 14px;
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			display: flex;
			justify-content: space-between;
			align-items: center;
			.time{
				color: #999999;
			}
			.tag {
				font-style: normal;
				padding:8px 12px;
				border-radius: 5px;
				text-align: center;
				color: #ff5c4f;
				min-width: 60px;
			}
		}

		.item_div1 {
			display: flex;
			justify-content: space-between;
			margin-bottom: 10px;
			font-size: 15px;
			p:nth-child(1) {
				width: 100%;
				font-weight: bold;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				color:#ffffff;
			}
		}

		.item_div2 {
			display: flex;
			justify-content: space-between;
			text-align: center;
			>div {
				flex: 1;
				p {
					padding: 5px 0;
				}
			}

			.item_rate {
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #e82637;

				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_day {
				width: 110px;
				text-align: center;
				flex: unset;
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #ffffff;
				}

				p:nth-child(2) {
					color: #999;
				}
			}

			.item_min {
				margin-left: -15px;
				p:nth-child(1) {
					font-weight: bold;
					font-size: 14px;
					color: #e82637;
				}

				p:nth-child(2) {
					color: #999;
				}
			}
		}
	}
	.items-flex{
		display: flex;
		padding: 15px;
		.flex_bd{
			flex: 1;
			min-width: 0;
		}
	}
	.item-ico{
		font-size: 0;
		margin-right: 10px;
		margin-top: -4px;
	}
	.item-ico img{
		width: 28px;
		height: 28px;
	}
	.m-card{
		background-color: #FFFFFF;
		text-align: center;
		border-radius: 10px;
		box-shadow: 0 1px 8px rgba(0, 0, 0, .1);
		padding: 10px 0;
	}
	.total-bar{
		background-color: #321770;
		text-align: center;
		box-shadow: 0 1px 8px rgba(0, 0, 0, .1);
		padding: 15px 0;
		.tot-desc{
			color: #999;
			font-size: 12px;
		}
		.icon-time-circle{
			font-size: 14px;
		}
		.tot-cell{
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	}
	.item_day{
		/deep/ .van-count-down{
			display: flex;
			align-items: center;
		}
	}
	.colon {
	    margin: 0 1px;
	    color: #999;
	  }
	  .block {
	    display: inline-block;
	    width: 22px;
	    color: #333;
	    font-size: 12px;
		border-radius: 4px;
	    text-align: center;
	    background-color: #e5e5e5;
	  }
	.show-tc-body{
		padding: 0px;
	}
	.show-tc-body p:first-child{
		text-align: center;
		font-size: 17px;
		color: #e82637;
		margin-bottom: 20px;
	}
	.popup{
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
		max-height: 80vh;
		padding: 26px 24px;
		overflow-y: auto;
		font-size: 14px;
		line-height: 20px;
	}
	
	
	
	
	
	
</style>
<style>
	
	.tot-cell  .icon-up{
		display: inline-block;
		animation:movetip 1s infinite
	}
	.tot-cell  .icon-down{
		display: inline-block;
		animation:movetip2 1s infinite
	}
	.color{
		animation:color 2s infinite
	}
	@keyframes movetip
	{
		from {transform:translateY(0);}
		to {transform:translateY(-5px);}
	}
	@keyframes movetip2
	{
		from {transform:translateY(0);}
		to {transform:translateY(5px);}
	}
	@keyframes color
	{
		0% {color: #000;}
		50% {color: #e82637;}
		100% {color: #04c382;}
	}
	
	
	
	
</style>
